module.exports = __webpack_public_path__ + "static/media/beautiful-bean-co-brown.a52a4da4.svg";